module.exports = __webpack_public_path__ + "img/high-discharging-end.b184a66a.png";